import React, { useState } from "react";
import Api from "../../../Api";
import Modal from "../../Utils/Modal";
import classes from "./styles.module.css";

function CrmPayoutActions(props) {
    var selectedIds = props.selectedIds;
    var token = props.token;
    var onComplete = props.onComplete;
    var onClearSelection = props.onClearSelection;
    var data = props.data; // весь список заявок — нужен для определения статусов выбранных
    var registries = props.registries || []; // реестры для "Добавить в реестр"
    var onMessage = props.onMessage || function () {};

    var _isLoading = useState(false);
    var isLoading = _isLoading[0];
    var setIsLoading = _isLoading[1];

    // Decline modal
    var _showDeclineModal = useState(false);
    var showDeclineModal = _showDeclineModal[0];
    var setShowDeclineModal = _showDeclineModal[1];

    var _declineReason = useState("");
    var declineReason = _declineReason[0];
    var setDeclineReason = _declineReason[1];

    // Registry modal (новый реестр)
    var _showRegistryModal = useState(false);
    var showRegistryModal = _showRegistryModal[0];
    var setShowRegistryModal = _showRegistryModal[1];

    var _registryName = useState("");
    var registryName = _registryName[0];
    var setRegistryName = _registryName[1];

    // Add to registry modal (существующий реестр)
    var _showAddToRegistryModal = useState(false);
    var showAddToRegistryModal = _showAddToRegistryModal[0];
    var setShowAddToRegistryModal = _showAddToRegistryModal[1];

    var _selectedRegistryId = useState(null);
    var selectedRegistryId = _selectedRegistryId[0];
    var setSelectedRegistryId = _selectedRegistryId[1];

    // Success modal
    var _showSuccessModal = useState(false);
    var showSuccessModal = _showSuccessModal[0];
    var setShowSuccessModal = _showSuccessModal[1];

    var _successFee = useState("");
    var successFee = _successFee[0];
    var setSuccessFee = _successFee[1];

    if (!selectedIds || selectedIds.length === 0) return null;

    // Определяем статусы выбранных заявок
    var selectedStatuses = [];
    var allData = Array.isArray(data) ? data : [];
    selectedIds.forEach(function (id) {
        for (var i = 0; i < allData.length; i++) {
            if (allData[i].id === id) {
                var s = Number(allData[i].status);
                if (selectedStatuses.indexOf(s) === -1) {
                    selectedStatuses.push(s);
                }
                break;
            }
        }
    });

    // Определяем, какие кнопки показывать
    var allAwaiting = selectedStatuses.length === 1 && selectedStatuses[0] === 7;
    var allInRegistry = selectedStatuses.length === 1 && selectedStatuses[0] === 3;
    var allFailed = selectedStatuses.length === 1 && selectedStatuses[0] === 6;
    var allCreated = selectedStatuses.length === 1 && selectedStatuses[0] === 0;

    // Можно ли отклонить — все выбранные должны быть в статусах 6 или 7
    var canDeclineStatuses = [0, 6, 7];
    var canDecline = selectedStatuses.every(function (s) {
        return canDeclineStatuses.indexOf(s) >= 0;
    });

    var showFormRegistry = allAwaiting;
    var showMoveBack = allInRegistry || allFailed;
    var showSendToAntifraud = allCreated;

    // Можно ли перевести в успех — все выбранные в статусах 3, 4 или 6
    var canMoveToSuccessStatuses = [3, 4, 6, 7];
    var canMoveToSuccess = selectedStatuses.every(function (s) {
        return canMoveToSuccessStatuses.indexOf(s) >= 0;
    });

    // Реестры в статусе Created (0) — можно добавлять заявки
    var availableRegistries = registries.filter(function (r) {
        return Number(r.status) === 0;
    });
    var showAddToRegistry = allAwaiting && availableRegistries.length > 0;

    // Отправить на антифрод
    function handleSendToAntifraud() {
        setIsLoading(true);
        new Api({ token: token }).sendToAntifraudCrmPayoutRequests(selectedIds)
            .then(function (result) {
                if (result.errors && result.errors.length > 0) {
                    var msg = "Отправлено: " + result.sent + ", ошибок: " + result.errors.length;
                    onMessage({ type: "warning", message: msg });
                } else {
                    onMessage({ type: "success", message: "Отправлено на антифрод: " + result.sent });
                }
                onComplete();
            })
            .catch(function (e) {
                onMessage({ type: "error", message: "Ошибка: " + (e.message || "Неизвестная ошибка") });
            })
            .then(function () {
                setIsLoading(false);
            });
    }

    // Массовое отклонение
    function handleBulkDecline() {
        if (!declineReason) {
            onMessage({ type: "warning", message: "Укажите причину отклонения" });
            return;
        }
        setIsLoading(true);
        new Api({ token: token }).bulkDeclineCrmPayoutRequests(selectedIds, declineReason)
            .then(function (result) {
                var msg = "Отклонено: " + result.declined;
                if (result.errors && result.errors.length > 0) {
                    msg += ", ошибок: " + result.errors.length;
                }
                onMessage({ type: result.errors && result.errors.length > 0 ? "warning" : "success", message: msg });
                setShowDeclineModal(false);
                setDeclineReason("");
                onComplete();
            })
            .catch(function (e) {
                onMessage({ type: "error", message: "Ошибка: " + (e.message || "Неизвестная ошибка") });
            })
            .then(function () {
                setIsLoading(false);
            });
    }

    // Вернуть в ожидание
    function handleMoveBack() {
        setIsLoading(true);
        new Api({ token: token }).moveBackToAwaitingCrmPayoutRequests(selectedIds)
            .then(function (result) {
                var msg = "Возвращено: " + result.moved;
                if (result.errors && result.errors.length > 0) {
                    msg += ", ошибок: " + result.errors.length;
                }
                onMessage({ type: result.errors && result.errors.length > 0 ? "warning" : "success", message: msg });
                onComplete();
            })
            .catch(function (e) {
                onMessage({ type: "error", message: "Ошибка: " + (e.message || "Неизвестная ошибка") });
            })
            .then(function () {
                setIsLoading(false);
            });
    }

    // Массовый перевод в успех
    function handleBulkMoveToSuccess() {
        setIsLoading(true);
        var fee = successFee ? parseFloat(successFee) : null;
        new Api({ token: token }).bulkMoveToSuccessCrmPayoutRequests(selectedIds, fee)
            .then(function (result) {
                var msg = "Переведено в успех: " + result.moved;
                if (result.errors && result.errors.length > 0) {
                    msg += ", ошибок: " + result.errors.length;
                    result.errors.forEach(function (err) {
                        msg += "\n#" + err.id + ": " + err.error;
                    });
                }
                onMessage({ type: result.errors && result.errors.length > 0 ? "warning" : "success", message: msg });
                setShowSuccessModal(false);
                setSuccessFee("");
                onComplete();
            })
            .catch(function (e) {
                onMessage({ type: "error", message: "Ошибка: " + (e.message || "Неизвестная ошибка") });
            })
            .then(function () {
                setIsLoading(false);
            });
    }

    // Формирование нового реестра
    function handleFormRegistry() {
        if (!registryName) {
            onMessage({ type: "warning", message: "Укажите название реестра" });
            return;
        }
        setIsLoading(true);
        new Api({ token: token }).formCrmRegistry(selectedIds, registryName, null)
            .then(function (result) {
                onMessage({ type: "success", message: "Реестр #" + result.registryId + " создан. Заявок: " + result.requestCount });
                setShowRegistryModal(false);
                setRegistryName("");
                onComplete();
            })
            .catch(function (e) {
                var msg = (e.response && e.response.data && e.response.data.message) || e.message || "Ошибка";
                onMessage({ type: "error", message: "Ошибка: " + msg });
            })
            .then(function () {
                setIsLoading(false);
            });
    }

    // Добавить в существующий реестр
    function handleAddToRegistry() {
        if (!selectedRegistryId) {
            onMessage({ type: "warning", message: "Выберите реестр" });
            return;
        }
        setIsLoading(true);
        new Api({ token: token }).addToCrmRegistry(selectedRegistryId, selectedIds)
            .then(function (result) {
                onMessage({ type: "success", message: "Добавлено " + result.addedCount + " заявок в реестр #" + result.registryId });
                setShowAddToRegistryModal(false);
                setSelectedRegistryId(null);
                onComplete();
            })
            .catch(function (e) {
                var msg = (e.response && e.response.data && e.response.data.message) || e.message || "Ошибка";
                onMessage({ type: "error", message: "Ошибка: " + msg });
            })
            .then(function () {
                setIsLoading(false);
            });
    }

    return (
        <React.Fragment>
            <div className={classes.Bar}>
                <span className={classes.Count}>
                    Выбрано: {selectedIds.length}
                </span>

                {showFormRegistry && (
                    <button
                        className={classes.BtnRegistry}
                        onClick={function () { setShowRegistryModal(true); }}
                        disabled={isLoading}
                    >
                        Сформировать реестр
                    </button>
                )}

                {showAddToRegistry && (
                    <button
                        className={classes.BtnAddToRegistry}
                        onClick={function () { setShowAddToRegistryModal(true); }}
                        disabled={isLoading}
                    >
                        Добавить в реестр
                    </button>
                )}

                {showMoveBack && (
                    <button
                        className={classes.BtnMoveBack}
                        onClick={handleMoveBack}
                        disabled={isLoading}
                    >
                        {isLoading ? "..." : "Вернуть в ожидание"}
                    </button>
                )}

                {canMoveToSuccess && (
                    <button
                        className={classes.BtnSuccess}
                        onClick={function () { setShowSuccessModal(true); }}
                        disabled={isLoading}
                    >
                        Перевести в успех
                    </button>
                )}

                {showSendToAntifraud && (
                    <button
                        className={classes.BtnMoveBack}
                        onClick={handleSendToAntifraud}
                        disabled={isLoading}
                    >
                        {isLoading ? "..." : "На антифрод"}
                    </button>
                )}

                {canDecline && (
                    <button
                        className={classes.BtnDecline}
                        onClick={function () { setShowDeclineModal(true); }}
                        disabled={isLoading}
                    >
                        Отклонить
                    </button>
                )}

                <button
                    className={classes.BtnClear}
                    onClick={onClearSelection}
                >
                    Снять выделение
                </button>
            </div>

            {/* Модалка перевода в успех */}
            <Modal
                isOpen={showSuccessModal}
                onClose={function () { setShowSuccessModal(false); }}
                title={"Перевод в успех (" + selectedIds.length + " заявок)"}
            >
                <div className={classes.ModalContent}>
                    <input
                        className={classes.Input}
                        type="number"
                        step="0.01"
                        placeholder="Комиссия (необязательно)"
                        value={successFee}
                        onChange={function (e) { setSuccessFee(e.target.value); }}
                    />
                    <div className={classes.ModalFooter}>
                        <button className={classes.BtnClear} onClick={function () { setShowSuccessModal(false); }}>
                            Отмена
                        </button>
                        <button className={classes.BtnSuccess} onClick={handleBulkMoveToSuccess} disabled={isLoading}>
                            {isLoading ? "..." : "Подтвердить"}
                        </button>
                    </div>
                </div>
            </Modal>

            {/* Модалка отклонения */}
            <Modal
                isOpen={showDeclineModal}
                onClose={function () { setShowDeclineModal(false); }}
                title={"Массовое отклонение (" + selectedIds.length + " заявок)"}
            >
                <div className={classes.ModalContent}>
                    <input
                        className={classes.Input}
                        placeholder="Причина отклонения..."
                        value={declineReason}
                        onChange={function (e) { setDeclineReason(e.target.value); }}
                    />
                    <div className={classes.ModalFooter}>
                        <button className={classes.BtnClear} onClick={function () { setShowDeclineModal(false); }}>
                            Отмена
                        </button>
                        <button className={classes.BtnDecline} onClick={handleBulkDecline} disabled={isLoading || !declineReason}>
                            {isLoading ? "..." : "Отклонить"}
                        </button>
                    </div>
                </div>
            </Modal>

            {/* Модалка формирования нового реестра */}
            <Modal
                isOpen={showRegistryModal}
                onClose={function () { setShowRegistryModal(false); }}
                title={"Сформировать реестр (" + selectedIds.length + " заявок)"}
            >
                <div className={classes.ModalContent}>
                    <label className={classes.ModalLabel}>Название реестра</label>
                    <input
                        className={classes.Input}
                        placeholder="Название реестра..."
                        value={registryName}
                        onChange={function (e) { setRegistryName(e.target.value); }}
                    />
                    <div className={classes.ModalFooter}>
                        <button className={classes.BtnClear} onClick={function () { setShowRegistryModal(false); }}>
                            Отмена
                        </button>
                        <button className={classes.BtnRegistry} onClick={handleFormRegistry} disabled={isLoading || !registryName}>
                            {isLoading ? "..." : "Создать реестр"}
                        </button>
                    </div>
                </div>
            </Modal>

            {/* Модалка добавления в существующий реестр */}
            <Modal
                isOpen={showAddToRegistryModal}
                onClose={function () { setShowAddToRegistryModal(false); setSelectedRegistryId(null); }}
                title={"Добавить в реестр (" + selectedIds.length + " заявок)"}
            >
                <div className={classes.ModalContent}>
                    <label className={classes.ModalLabel}>Выберите реестр</label>
                    <div className={classes.RegistryList}>
                        {availableRegistries.map(function (reg) {
                            var isSelected = selectedRegistryId === reg.id;
                            return (
                                <div
                                    key={reg.id}
                                    className={classes.RegistryOption + (isSelected ? " " + classes.RegistryOptionSelected : "")}
                                    onClick={function () { setSelectedRegistryId(reg.id); }}
                                >
                                    <div className={classes.RegistryOptionName}>
                                        {reg.name || "Реестр #" + reg.id}
                                    </div>
                                    <div className={classes.RegistryOptionInfo}>
                                        {reg.requestCount} заявок, {(reg.totalAmount || 0).toLocaleString("ru-RU", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} &#8381;
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <div className={classes.ModalFooter}>
                        <button className={classes.BtnClear} onClick={function () { setShowAddToRegistryModal(false); setSelectedRegistryId(null); }}>
                            Отмена
                        </button>
                        <button className={classes.BtnAddToRegistry} onClick={handleAddToRegistry} disabled={isLoading || !selectedRegistryId}>
                            {isLoading ? "..." : "Добавить"}
                        </button>
                    </div>
                </div>
            </Modal>
        </React.Fragment>
    );
}

CrmPayoutActions.defaultProps = {
    selectedIds: [],
    data: [],
    registries: [],
    onComplete: function () {},
    onClearSelection: function () {},
};

export default CrmPayoutActions;



// WEBPACK FOOTER //
// ./src/Components/ComponentsOfAdministrator/CrmPayoutActions/index.js